import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class Draft extends DomainObject {
  draftObject;
  autosavedAt;

  constructor(other) {
    super();

    makeObservable(this, {
      draftObject: observable,
      autosavedAt: observable
    });

    this.merge(other);
  }
}

export default Draft;
